import { render } from "./invisionSelect.vue?vue&type=template&id=68662570"
import script from "./invisionSelect.vue?vue&type=script&lang=js"
export * from "./invisionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__